module.exports = __webpack_public_path__ + "img/icon14.7ffe2d6e.png";